<template>
  <div>
    <div class="mb-3" v-for="[key, value] in Object.entries(secretValues)" :key="`${key}/${value}`">
      <div class="d-flex flex-wrap gap-2 mb-1 w-100">
        <div class="hstack align-items-center" style="width: 40%; min-width: 120px; max-width: 250px; flex-grow: 1; flex-shrink: 0; flex-basis: 0;">
          <div class="h6 mb-0 fw-semibold align-self-center">{{ $t(`js.backend.voter_secrets.voter_attribute.${key}`) }}</div>
        </div>
        <div class="hstack align-items-center" style="width: 60%; min-width: 120px;">
          <input v-if="editable && value !== null" class="form-control" type="text" v-model="secretValues[key]"
                 :name="`voter[${key}]`" :id="`voter_${key}`">
          <p class="text-muted mb-0" v-if="value && !editable">{{ value }}</p>
          <AsyncButton v-if="value === null" @click="reveal(key)" class="btn btn-sm btn-secondary mt-1">
            <AVIcon icon="eye" />
            {{ $t("js.backend.voter_secrets.reveal") }}
          </AsyncButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "@/types";
import apiClient from "@/entrypoints/frontend/apiClient";
import AsyncButton from "@/components/shared/AsyncButton.vue";

export default defineComponent({
  name: "VoterSecrets",
  components: { AsyncButton },
  props: {
    voter_id: {
      type: Number,
      required: true,
    },
    secrets: {
      type: Array as PropType<string[]>,
      required: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data: ({ secrets }) => ({
    secretValues: Object.fromEntries(secrets.map((s: string) => [s, null])),
  }),
  methods: {
    async reveal(key: string) {
      const url = this.editable ? "../" + this.voter_id + "/reveal" : this.voter_id + "/reveal";
      const res = await apiClient.get(url, {
        params: { secret: key }
      });

      if (res.status >= 200 && res.status < 300) {
        this.secretValues[key] = res.data[key];
      }
    },
  },
});
</script>
